import React from 'react';
import type { NextPage } from 'next';

import BuoyMap from 'containers/BuoyMap';
import { getOrCreateStore, type ReduxInitialProps } from 'stores';

const BuoyMapPageWithLocation: NextPage<
  {},
  ReduxInitialProps & { isMapV2Page: true; mapMode: 'buoy' }
> = () => <BuoyMap />;

BuoyMapPageWithLocation.getInitialProps = async (context) => {
  const isServer = !!context.req;
  const { location } = context.query as { location: string };

  if (isServer) {
    const newrelic = require('newrelic');
    newrelic.addCustomAttributes({
      location,
    });

    const store = getOrCreateStore();
    return {
      isAppBannerEnabled: true,
      isFooterVisible: false,
      isMapV2Page: true,
      mapMode: 'buoy',
      ssrReduxState: store.getState(),
    };
  }

  return {
    isAppBannerEnabled: true,
    isFooterVisible: false,
    isMapV2Page: true,
    mapMode: 'buoy',
  };
};

export default BuoyMapPageWithLocation;
